<div class="modal-header">
    <h5 class="modal-title">
      <i class="fa fa-cogs"></i> {{ name }} – {{ 'Skill Details' | translate }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
  
  <div class="modal-body">
    <div *ngIf="matchedSkills.length > 0">
      <strong class="text-success">{{ 'Matched Skills' | translate }}</strong>
      <ul>
        <li *ngFor="let skill of matchedSkills">
          <i class="fa fa-check text-success"></i> {{ skill }}
        </li>
      </ul>
    </div>
  
    <div *ngIf="unmatchedSkills.length > 0">
      <strong class="text-danger">{{ 'Unmatched Skills' | translate }}</strong>
      <ul>
        <li *ngFor="let skill of unmatchedSkills">
          <i class="fa fa-times text-danger"></i> {{ skill }}
        </li>
      </ul>
    </div>
  
    <div *ngIf="matchedSkills.length === 0 && unmatchedSkills.length === 0" class="text-muted">
      {{ 'No skill details available.' | translate }}
    </div>
  </div>
  
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="activeModal.close()">
      <i class="fa fa-times"></i> {{ 'Close' | translate }}
    </button>
  </div>
  